
import XTable from 'vux/src/components/x-table/index.vue'

import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import editAddress from '../mine/personalSettings/editAddress.vue';
export default {
components: {
XTable,
Checker,
CheckerItem,
editAddress
},
data() {
return {
address: null,
addressList: [],
goodsList: [],
totalPrice: 0,
remark: '',
addressPopupShow: false,
submitFlag: true, //提交按钮节流
};
},
methods: {
goBack() {
let that = this;
that.$vux.confirm.show({
content: "您确认要放弃支付吗？",
cancelText: '取消',
confirmText: '确定',
title: '提示',
onConfirm() {
that.$router.go(-1);
}
});
},
getAddress() {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/receiverAddress', {
params: {
shopperId: that.$store.state.userInfo.shopperId
}
})
.then(function (res) {
if (res.status == 200) {
var flag = false;
that.addressList = res.body.map(item => {
item.desc = item.regionDesc.replace(/\s/g, '') + item.address;
return item;
});

res.body.forEach(item => {

if (item.defaultAddress == 1) {
item.desc = item.regionDesc.replace(/\s/g, '') + item.address;
that.address = item;
flag = true;
}
});
if (!flag && res.body.length > 0) {

var one = res.body[0];
one.desc = one.regionDesc.replace(/\s/g, '') + one.address;
that.address = one;
flag = true;
}
if (!flag) {
that.address = null;
}
}
});
},
selectAddress(value) {

this.address = value;
},
toAddressManage(type, item) {
this.$refs.editAddressRef.showPopup(type, item);
},

buttonFlag(code) {
if (!this[code]) {
this.$vux.toast.text('请不要快速点击');
return false;
} else {
this[code] = false;
setTimeout(() => {
this[code] = true;
}, 1500);
return true;
}
},
submit() {
if (!this.buttonFlag('submitFlag')) {
return false;
}
if (!this.address || !this.address.name || !this.address.phoneNum || !this.address.desc) {
this.$vux.toast.text('请选择收货地址');
return false;
}
if (!this.goodsList || this.goodsList.length <= 0) {
this.$vux.toast.text('没有商品信息，请返回首页重新选择购买');
return false;
}
var orderCartIdList = [];
var orderDetailsList = this.goodsList.map((item, index) => {
item.buyNum = item.number;
item.buyPrice = item.sellingPrice;
item.shareDetail = item.shareDetail ? item.shareDetail : '分享描述';
if (item.orderCartId) {
orderCartIdList.push(item.orderCartId);
}
item.photo = item.poster;
if (!item.isSuit && item.isSuit != 0) {
item.isSuit = item.isSuitKey;
}
item.orderNum = index + 1;
return item;
});
var goodsOrder = {
goodsTotalPrices: this.totalPrice,
discountsPrices: 0,
freightPrices: 0,
shippingMethod: 0,
orderTotalPrices: this.totalPrice,
customerMessage: this.remark,
orderDetailsList: orderDetailsList,
...this.address
};
var data = {
goodsOrder: JSON.stringify(goodsOrder),
shopperId: this.$store.state.userInfo.shopperId
};
if (orderCartIdList && orderCartIdList.length > 0) {
data.orderCartIdList = JSON.stringify(orderCartIdList);
}
let that = this;
that.$axios.post('/api/v1.0/lonbonShop/buy', that.qs.stringify(data)).then(function (response) {
if (response.status == 200) {
that.$store.state.APPPAGE.getOrderCartNum();
if (orderCartIdList && orderCartIdList.length > 0) {
that.$router.push("mallOrderDetail?readyPayOrderId=" + response.body + "&openPay=true&fromCart=true");
} else {
that.$router.push("mallOrderDetail?readyPayOrderId=" + response.body + "&openPay=true");
}

}
});
}
},
mounted() {
var goodsList = sessionStorage.readyBuyGoods;
if (goodsList) {
this.goodsList = JSON.parse(goodsList);
var totalPrice = 0;
this.goodsList.forEach(item => {
totalPrice += item.number * item.sellingPrice;
});
this.totalPrice = totalPrice;
this.getAddress();
} else {
this.$router.push('/goods');
}
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/shoppingCart/settlement.vue